import Vue from "vue";

import Vue2TouchEvents from 'vue2-touch-events';
// @ts-ignore
import vClickOutside from 'v-click-outside';

Vue.use(Vue2TouchEvents);
Vue.use(vClickOutside);
